import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class LoginInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(req.url.includes("login")){
      const headers = req.clone({
        headers: req.headers.set('application','web;')
      });
      return next.handle(headers);
    }else{
      return next.handle(req);
    }
  }

}
